// Splits audit-trail event kinds into "key" (always shown) and "routine" (hidden behind the
// "Key events" filter). This is a PRODUCT classification, not a technical one — it decides what a
// reviewer sees by default — so it's meant to be reviewed and tuned with product, and lives in one
// place on purpose. Everything NOT listed here counts as "key".
//
// Values are the API's `DbUserTimelineEventKind` (snake_case) — the vocabulary the timeline
// endpoint's `kinds`/`excludeKinds` params accept. Note this differs from the frontend
// `UserTimelineEvent['kind']` in one spot: document uploads are `identity_document_uploaded` here
// (the API kind) but `document_uploaded` on a loaded event.
export const ROUTINE_EVENT_KINDS = [
  'data_collected',
  'identity_document_uploaded',
  'liveness',
  'workflow_started',
  'onboarding_inherited',
  'vault_created',
  'auth_method_updated',
  'conditional_branch_executed',
  'onboarding_timeline',
  'provider_result',
  'external_integration_called',
] as const;

// `device_insight` is already always excluded by useEntityTimeline, so the hook merges it in
// rather than repeating it here.
export const KEY_VIEW_EXCLUDE_KINDS = ROUTINE_EVENT_KINDS.join(',');

export type AuditTrailScope = 'all' | 'key';

// The header (count) and the timeline (list) both query through this, so one stable object keeps
// them on the same react-query key — a single deduped fetch.
const KEY_SCOPE_QUERY = { excludeKinds: KEY_VIEW_EXCLUDE_KINDS };

export const scopeToTimelineQuery = (scope: AuditTrailScope) => (scope === 'key' ? KEY_SCOPE_QUERY : undefined);
